export enum ComplaintReasons {
    DUBIOUS = 'erscheint unseriös',
    FAKE = 'ist keine reale Immobilie',
    INCORRECT_LOCATION = 'ist am falschen Ort platziert',
    UNAVAILABLE = 'ist bereits verkauft / vermietet',
    ALIENATED = 'wird zweckentfremdet (z.B. zur Unternehmensdarstellung oder als Werbung)',
    EMPTY = '',
}
